var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.884277,
    y: 0.805664,
    width: 31.3863,
    height: 31.3863,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_87_172",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_87_172",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE4UlEQVR4nO2cz4scRRTHv0qMJ11/gFHQsyiiUfwfNnpRk3jVxBAEcVXiQVRwB8FkvZlEJa4Ket2AkRDizHu9zEWQVW96chXBk1GjLvgD/MFXqqfHXWZ7emenO1OvauoDDwLpH1Wf7Wmqq94rIJFIJBKJRCKxASpmqFik4Jc83L8VMxuPSdSExGUUCBUciMz9X93rJwqoeKREci8EB/vHJUpgB7uZ4RAVe9jFjqHHncO1FHw/VLTiByquH3p+FzsouJ+Cw1TcjWmCipMDsr6iYO+m47q4hgKtkNyPZfcHKbnPPipWB34Bb2AaoGBvxWtghYJnKXiSiteoWBtBcj/WKDhOxVxxjZWKY/chdtgbLdBrCN5B7FCxZED0acQOBWcMiD6D2GH5eHjSogUxw/O4koKfDIj+kUvYiVih4FXvktdjAVE+yYoFKv41ILgfri0Lrm0IdE7iYTd8KkYXLjomXhfDXyOubZ3/2+vanmE/LEPFm97FaWN/AJtfkMxwj3c52nB0sBvWYIbHvYvRxp/qw7AGM9znXYw2HntgjXw6cnCmLOQQfM3PcQUsUkxLMorIDI88iuHdp94lae34zPwSGRVHDIhizTgC61DxlAFRrBlzsA4FJwyIYs04CcvkC6nbW36i0VgrW4M0Adu4Ll8k9S+JDcWy6xNMjTRc3kV1SgADjYsUPM15XO5XsksHcNlC/oXwkj/dPtPPqHjbgAROKBb9ie4lG3JK4uckWici+uJ0J8PohEJwyqfomRFz4xh0uD6ex9XeROey0/DOywdLPEM9gZj6YCkZV8fwCf6r6wssE8WkkuA4rJPnJ/sWpbXjCVgniol/wTOwzhaZ9gwiBCuwTFSLs7K5psYE0aUbKFarqsW8kZeY+ZfDhp/qWVgjypSwDIdgDVcsGaHoO2ERKl73LkcbCsEJBFCwubghEb2d14zYFera1t7Q3kV28BBChEvYWdSvWCutOBZl0RAtFQsJjiJWaKX8ze2IEOOTbK6gU9FBiFDxADPsiq1EmV3cyAwPwgJUtIrG/0XFWSpecbvCsIubS48XnPYuWrFU2rY2bsnbLjhKxbmiT+74FkxILo9HS8+RvAbRZDIMOzhQcU7LomT3hL9Yel6G/RXnrBTz2XPFSs14G6O4a1RN1w4ZJ1Pw0hb3aNmS3IsPtvEFuVq2K8zIuX0uHaBkjW/IVj9Dl6mKVx9NyB5RsuvQH/wYVw29Tht35ZtXCWYrN6/qra5fqLjXharV6mLzqlkqHquau3B5GxT8OeKvp2VD8rrs+UbuKzhY8Ro40NA9XjaxO8K2JffiNy7j1oaSdLLSV0YD1VPMcDsVv4/Rv5YFyevv3w5uaCj97K08ObyXIH6qiTQtN/6n4Jsa/WtZkNyPby1u7kfBvVR810D/WhYks/iZ/11s4npb6b0+wk0UvEDBl3UKdYqCpS+oeN592ZUe08EdFLxLxT+N9W9c2Y1K1k3hdm78MH8VCN6j4pMmv8IGvlbdtd8vqhPO5jXel65fEx9nj/vUzzfWBsFz47YDoeBbcl3ZCAULkuvIRihYkTyubISCJcnjyEYoWJO8XdkIBYuStyMboWBV8qiyEQqWJY8iG6FgXfJWshEKIUiuko1QCEXyMNkIhZAkl8lGKIQmeVA2QsF7wsmUtj2RSCQSiQQS+A+UREj1+AlI0QAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.545ab3d99f51687ffab6e6b4054dd8b0.svg";
export { ForwardRef as ReactComponent };